/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Flow_StageInputs */

const en_task_flow_stage = /** @type {(inputs: Task_Flow_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating it moves the case to`)
};

const pt_br2_task_flow_stage = /** @type {(inputs: Task_Flow_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ao ser criada, move o caso para`)
};

/**
* | output |
* | --- |
* | "Creating it moves the case to" |
*
* @param {Task_Flow_StageInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_stage = /** @type {((inputs?: Task_Flow_StageInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_StageInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_stage(inputs)
	return pt_br2_task_flow_stage(inputs)
});